import axios, { type AxiosError } from 'axios'
import {
  useQuery,
  type QueryKey,
  type UseQueryOptions,
} from '@tanstack/react-query'

import getAccessToken from '@/utils/getAccessToken'

const useAuthenticatedQuery = <T>(
  queryKey: QueryKey,
  url: string,
  options?: Omit<UseQueryOptions<T>, 'queryKey' | 'queryFn'>,
  customErrorMessage?: string,
) =>
  useQuery<T>({
    queryKey: Array.isArray(queryKey) ? queryKey : [queryKey],
    queryFn: async () => {
      const token = await getAccessToken()
      if (!token) throw new Error('No access token available')

      try {
        const { data } = await axios.get<T>(url, {
          headers: { Authorization: `Bearer ${token}` },
        })
        return data
      } catch (error) {
        const e = error as AxiosError
        console.error('Query error:', {
          url,
          status: e.response?.status,
          message: e.message,
        })
        throw customErrorMessage ? new Error(customErrorMessage) : error
      }
    },
    ...options,
  })

export default useAuthenticatedQuery
